export default __webpack_public_path__ + "static/media/ods2.541932c4.svg";